import { render, staticRenderFns } from "./OVActionHistory.vue?vue&type=template&id=d0a8bb76&scoped=true&lang=pug"
import script from "./OVActionHistory.vue?vue&type=script&lang=js"
export * from "./OVActionHistory.vue?vue&type=script&lang=js"
import style0 from "./OVActionHistory.vue?vue&type=style&index=0&id=d0a8bb76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a8bb76",
  null
  
)

export default component.exports